import React from 'react';
import { Route } from 'react-router-dom';

import { lazy } from '@components/common/routeLoading';
import { Path } from '@components/routes/constants';
import { SECTION } from '@hooks/useDocumentTitle/constants';
import { RedirectRoute } from '@components/routes/redirect';

const EventBlockingPage = lazy(() =>
  import(/* webpackChunkName: "eventBlocking" */ '@components/eventBlocking').then((module) => ({
    default: module.EventBlockingPage,
  })),
);

/** See the note in @components/botManagement/routes on why these are definitions. */
export const eventBlockingRoutes = (
  <Route
    key={Path.EVENT_BLOCKING}
    path={Path.EVENT_BLOCKING}
    handle={{ section: SECTION.eventBlocking }}
  >
    <Route index element={<EventBlockingPage />} />
    <Route path="*" element={<RedirectRoute />} />
  </Route>
);
